<template>
    <!-- :class="{ 'isiOSX': isiOSX }" -->
    <div class="integral-wrap">
        <!-- <van-nav-bar @click-left="goBack" :border="false" left-arrow>
            <template #left> -->
        <img class="left-arraw" @click="goBack" src="../../assets/lifecircle/left-arraw.png" alt="">
        <!-- </template> -->
        <!-- </van-nav-bar> -->
        <div class="integral-bg-wrap">
            <img class="integral-bg" src="../../assets/lifecircle/integral-bg.png" alt="">
            <div class="integral-today-comein">今日收益：{{today_income}}积分</div>
        </div>
        <div class="integral-task">
            <div class="integral-task-item" v-show="new_task.length">
                <div class="task-title-bg">
                    <div class="task-title">新人任务</div>
                </div>
                <div class="task-list">
                    <div v-for="(item, index) in new_task" :key="item._id" class="task-item">
                        <img class="task-icon" :src="imgPath(item.child_type)" alt="">
                        <div class="task-item-info">
                            <div class="task-info-box">
                                <div class="task-info-title">{{ item.title }}<span v-if="item.child_type === 'J42A4'">{{item.complete_num}}/{{item.num}}</span></div>
                                <div class="task-gold">
                                    <img src="../../assets/lifecircle/task-gold.png" alt="">
                                    <span>+{{ item.integral }}积分</span>
                                </div>
                            </div>
                            <div class="task-info-desc">{{ item.desc }}</div>
                        </div>
                        <div :class="['lottie-animate', btnStyle(item.status)]">
                            <div v-if="btn_animate_index === 'newtask-lottie' + index" class="lottie-box"
                                :id="'newtask-lottie' + index"></div>
                            <van-button :disabled="item.status === 2" @click="receiveFn(item, 'newtask-lottie' + index, index)">{{ btnText(item) }}
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="integral-task-item" v-show="day_task.length">
                <div class="task-title-bg">
                    <div class="task-title">每日任务</div>
                </div>
                <div class="task-list">
                    <div v-for="(item, index) in day_task" :key="item._id" class="task-item">
                        <img class="task-icon" :src="imgPath(item.child_type)" alt="">
                        <div class="task-item-info">
                            <div class="task-info-box">
                                <div class="task-info-title">{{ item.title }}{{item.complete_num}}/{{item.num}}</div>
                                <div class="task-gold">
                                    <img src="../../assets/lifecircle/task-gold.png" alt="">
                                    <span>+{{ item.integral }}积分</span>
                                </div>
                            </div>
                            <div class="task-info-desc">{{ item.desc }}</div>
                        </div>
                        <div :class="['lottie-animate', btnStyle(item.status)]">
                            <div v-if="btn_animate_index === 'daytask-lottie' + index" class="lottie-box"
                                :id="'daytask-lottie' + index"></div>
                            <van-button :disabled="item.status === 2" @click="receiveFn(item, 'daytask-lottie' + index, index)">{{ btnText(item) }}
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="integral-task-item">
                <div class="task-title-bg">
                    <div class="task-title">限时任务</div>
                </div>
                <div class="task-list">
                    <div class="task-item">
                        <img class="task-icon" src="../../assets/lifecircle/task-timelimit.png" alt="">
                        <div class="task-item-info">
                            <div class="task-info-box">
                                <div class="task-info-title">参与热议话题活动赚积分</div>
                            </div>
                        </div>
                        <div class="task-nodone">
                            <van-button @click="receiveFn()">去参与</van-button>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <van-popup v-model="popup_post_show" :close-on-click-overlay="false">
            <div class="rules-modal">
                <div class="rules-head-bg">
                    <img src="../../assets/lifecircle/rule-pic.png" alt="">
                    <div class="rules-title">发帖规则</div>
                </div>
                <div class="rules-text">1. 每条内容20个字以上，不能用数字、标点、表情凑字数。</div>
                <div class="rules-text">2. 审核通过后即可领取奖励。</div>
                <img class="rules-close" @click="closePopup('J42A2', 'popup_post_show')" src="../../assets/lifecircle/task-close.png" alt="">
            </div>
        </van-popup>
        <van-popup v-model="popup_comments_show" :close-on-click-overlay="false">
            <div class="rules-modal">
                <div class="rules-head-bg">
                    <img src="../../assets/lifecircle/rule-pic.png" alt="">
                    <div class="rules-title">评价规则</div>
                </div>
                <div class="rules-text">1. 每条评论5个字以上，不能用数字、标点、表情凑字数。</div>
                <div class="rules-text">2. 审核通过后即可领取奖励。</div>
                <img class="rules-close" @click="closePopup('J42A3', 'popup_comments_show')" src="../../assets/lifecircle/task-close.png" alt="">
            </div>
        </van-popup>
        <audio hidden ref="audio" src="../../assets/lifecircle/gold.mp3"></audio>
    </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import lottie from 'lottie-web'
import * as lotties from '../../assets/lifecircle/animate/integral.json'
const path = require('../../assets/lifecircle/animate/images/img_0.png')
lotties.assets[0].p = path
const task_type = new Map([
    ['J42A1', () => GoSettingAccount.postMessage('')],//完善头像
    ['J42A2', () => GoToReleasePage.postMessage('')],//首次发帖
    ['J42A3', () => GoSquare.postMessage('')],//首次评论
    ['J42A4', () => GoSquare.postMessage('')],//关注
    ['J42A5', () => GoToReleasePage.postMessage('')],//发帖
    ['J42A6', () => GoSquare.postMessage('')],//评论
    ['J42A7', () => GoSquare.postMessage('')]//点赞
])
export default {
    data() {
        this.lottie = null
        this.timer = null
        this.disabled = false
        this.popup_post_disable = false
        this.popup_comments_disable = false
        this.is_authentication = 0
        return {
            isiOSX: false,
            day_task: [],
            new_task: [],
            topic_task: [],
            today_income: 0,//今日收益积分
            btn_animate_index: '',//当前动画位置
            popup_post_show: false,
            popup_comments_show: false
        }
    },
    created() {
        this.isiOSX = this.isIphoneX()
        this.getTaskList()
        window.callBackData = (data)=> {
            if (data.refresh) {
                this.getTaskList()
            }
        }
    },
    methods: {
        goBack() {
            GoBack.postMessage('')
        },
        closePopup(type, prop){
            this[prop] = false
            task_type.get(type)()
        },
        recieveTasks(item, ele) {
            if (this.disabled) return
            this.disabled = true
            this.$api.post("/life-moments/member/receive/integral", {task_id: item._id}).then((res) => {
                if (this.lottie) {
                    this.lottie.destroy()
                    this.lottie = null
                }
                if (this.timer) {
                    clearTimeout(this.timer)
                    this.timer = null
                }
                this.btn_animate_index = ele
                this.$nextTick(() => {
                    this.lottie = lottie.loadAnimation({
                    container: document.getElementById(ele),
                        renderer: 'svg',
                        loop: true,
                        animationData: lotties.default
                    })
                    this.$refs.audio.play()
                    this.timer = setTimeout(()=>{
                        this.lottie.destroy()
                        this.lottie = null
                        this.disabled = false
                        this.btn_animate_index = ''
                    },1000)
                })
                this.disabled = false
                this.getTaskList()
            }).catch((err) => {
                this.disabled = false
                if (err.response && err.response.data) {
                    Toast(err.response.data.message)
                }
            })
        },
        receiveFn(item, ele) {
            switch(item.status){
                case 0:
                    if (item.type === 1) {
                        //判断是否首次点击发帖或者评论
                        if (item.child_type === 'J42A2' && !this.popup_post_disable) {
                            this.popup_post_show = true
                            this.popup_post_disable = true
                        }else if (item.child_type === 'J42A3' && !this.popup_comments_disable){
                            this.popup_comments_disable = true
                            this.popup_comments_show = true
                        }else{
                            task_type.get(item.child_type)()
                        }
                    }else{
                        task_type.get(item.child_type)()
                    }
                    break
                case 1:
                    //是否实名认证
                    if (this.is_authentication === 1) {
                        this.recieveTasks(item, ele)
                    }else{
                        Dialog.confirm({
                            title: '实名认证',
                            message: '为了保障您的积分财产安全，在领取奖励前，请先完成实名认证。',
                            confirmButtonText: '去实名认证',
                            confirmButtonColor: '#F9591B'
                        }).then(() => {
                            GoToVerifiedPage.postMessage('')
                        }).catch(() => {})
                    }
                    break
                case 2:
                    break
            }
        },
        imgPath(type) {
            switch (type) {
                case 'J42A1':
                    return require('../../assets/lifecircle/task-avatar.png')
                case 'J42A2':
                    return require('../../assets/lifecircle/task-edit.png')
                case 'J42A3':
                    return require('../../assets/lifecircle/task-comment.png')
                case 'J42A4':
                    return require('../../assets/lifecircle/task-follow.png')
                case 'J42A5':
                    return require('../../assets/lifecircle/task-edit.png')
                case 'J42A6':
                    return require('../../assets/lifecircle/task-comment.png')
                case 'J42A7':
                    return require('../../assets/lifecircle/task-thumbs.png')
                default:
                    return require('../../assets/lifecircle/task-timelimit.png')
            }
        },
        btnStyle(status) {
            switch (status) {
                case 0:
                    return 'task-nodone'
                case 1:
                    return 'task-waitrecevie'
                case 2:
                    return 'task-done'
            }
        },
        btnText(item) {
            switch(item.status){
                case 0:
                    return item.button_text_active
                case 1:
                    return item.button_text_receive
                case 2:
                    return item.button_text_complete
            }
        },
        getTaskList() {
            this.$api.post("/life-moments/member/task/center").then((res) => {
                this.day_task = res.day_task
                this.new_task = res.new_task
                this.topic_task = res.topic_task
                this.today_income = res.today_income
                this.is_authentication = res.is_auth
            })
        }
    }
}
</script>

<style lang="less" scoped>
.integral-wrap {
    box-sizing: border-box;
    min-height: 100vh;
    padding-bottom: 60px;
    background-color: #FAF0D8;

    .left-arraw {
        position: fixed;
        top: 55px;
        left: 15px;
        width: 24px;
        height: 24px;
        z-index: 5;
    }

    .van-nav-bar {
        position: fixed;
        background-color: transparent;
        width: 100%;
        z-index: 3;
    }

    .integral-bg-wrap {
        position: relative;
        z-index: 1;

        .integral-today-comein {
            position: absolute;
            top: 189px;
            left: 40px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #B54718;
        }
    }

    .integral-bg {
        width: 100%;
        height: 360px;
    }

    .integral-task {
        position: relative;
        margin-top: -145px;
        padding: 0 12px;
        z-index: 2;

        .integral-task-item {
            margin-bottom: 20px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 12px 0px rgba(220, 36, 0, 0.12);
            border-radius: 12px;
        }

        .task-list {
            padding: 0 12px 20px 12px;
        }

        .task-item {
            display: flex;
            align-items: center;
            margin-top: 8px;
            height: 65px;
            padding: 0 8px;
            background-color: #FFF4E2;
            border-radius: 8px;

            .task-icon {
                width: 49px;
            }

            .task-info-desc {
                margin-top: 4px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #DE6300;
            }

            .task-item-info {
                flex: 1;
                margin-left: 8px;
                padding: 12px 0;
            }

            .task-info-box {
                display: flex;
                align-items: center;

                img {
                    width: 16px;
                    height: 16px;
                }

                .task-info-title {
                    font-size: 14px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                }

                .task-gold {
                    display: flex;
                    align-items: center;
                    margin-left: 4px;
                    height: 16px;
                    background-color: rgba(255, 199, 19, 0.2);
                    border-radius: 9px;
                    font-size: 10px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #B54718;

                    span {
                        margin: 0 4px;
                    }
                }
            }

            .lottie-animate {
                position: relative;

                .lottie-box {
                    position: absolute;
                    top: -80px;
                    left: -9px;
                    width: 80px;
                    height: 80px;
                }
            }

            .van-button {
                width: 62px;
                height: 30px;
                padding: 0;
                border-radius: 22px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
            }

            .task-done .van-button {
                color: #cf9981;
                background-color: rgba(222, 99, 0, .2);
            }
            .task-done .van-button--disabled{
                opacity: 1;
            }
            .task-nodone .van-button {
                background: linear-gradient(180deg, #FFC961 0%, #FF6220 100%);
            }

            .task-waitrecevie .van-button {
                background: linear-gradient(90deg, #FF7641 0%, #FF0B40 100%);
            }
        }

        .task-title-bg {
            width: 100%;
            height: 46px;
            background-image: url('../../assets/lifecircle/integral-task-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;

            .task-title {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                margin-left: 30px;
                line-height: 46px;
            }
        }
    }
}
.van-popup{
    background-color: transparent;
    overflow-y: unset;
}
.rules-modal{
    position: relative;
    width: 273px;
    height: 210px;
    background-color: #ffffff;
    border: 6px solid #FFE671;
    border-radius: 12px;
    .rules-head-bg{
        position: relative;
        transform: translate(36px, -12px);
        width: 201px;
        height: 50px;
        img{
            width: 201px;
            height: 50px;
        }
    }
    .rules-title{
        position: absolute;
        top: 11px;
        left: 61px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #C60B00;
        line-height: 28px;
    }
    .rules-close{
        position: absolute;
        bottom: -70px;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 40px;
    }
    .rules-text{
        padding: 25px 24px 0 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
    }
}
.isiOSX {
    .van-nav-bar {
        padding-top: 43px;
    }

    .help-content {
        padding-top: 90px;
    }
}
</style>